/**
 * TRAD-3867 — 인사이트(Insights) 섹션. 🔸 10/30 davidyoon «인사이트» 별도 섹션 → `/finance` → `/insights` 로 옮겼다(계약 v6 §7 web 줄).
 * `/finance` 는 dev 에만 배포됐던 주소라(운영 미배포 — SEO 영향 0) 리다이렉트만 남긴다(`legacyFinance*`).
 * 🔴 앱 웹뷰(iOS·Android)가 `/insights/{slug}?src=app&embed=1&theme=` 와 `#map`·`#table` 을 이 주소에 맞춘다 — 바꾸면 3사 동시.
 */
export const financeRoutePaths = {
  finance: {
    path: 'insights',
    url: '/insights',
  },
  financeContent: {
    path: 'insights/:slug',
  },
  /** 관계 지도·표(10/30 22:2x 목록에서 분리). 정적 경로라 `insights/:slug` 보다 우선한다(React Router 랭킹). */
  financeRelations: {
    path: 'insights/relations',
    url: '/insights/relations',
  },
  /** 공유(캡처) 카드 — MainLayout 밖 · noindex(팀장 10/30). marketer relation-card.py 가 `[data-card="pair"]` 를 여기서 잡는다. */
  financeShareCard: {
    path: 'insights/:slug/card',
  },
  legacyFinance: {
    path: 'finance',
  },
  legacyFinanceContent: {
    path: 'finance/:slug',
  },
} as const;

/** `/insights/<slug>/card`(끝 슬래시 허용) — RootLayout 이 쿠키 배너를 안 띄우는 판정. 순수 함수. */
export const isInsightsShareCardPath = (pathname: string): boolean => /^\/insights\/[^/]+\/card\/?$/.test(pathname);
